import { Component } from "react";

class Strategy1InfoBox extends Component {
  render() {
    return (
      <div className={this.props.show ? "modal is-active" : "modal"}>
        <div className="modal-background" onClick={this.props.handleClose}></div>

        <div className="modal-card wide-modal">
          <header className="modal-card-head">
            <h5 className="modal-card-title">Condition Info (Strategy #1)</h5>
            <button className="delete" onClick={this.props.handleClose}></button>
          </header>

          <section className="modal-card-body">
            <p className="subtitle">Statistics info of condition - #{this.props.condition.id}</p>

            <h4 className="is-size-4 mb-3">Inputs:</h4>

            <table className="table is-striped is-hoverable is-fullwidth is-bordered">
              <tbody>
                <tr>
                  <th>Broker/Datafeed:</th>
                  <td>{this.props.condition.brokerName} / {this.props.condition.datafeedName}</td>
                </tr>
                <tr>
                  <th>Scrip:</th>
                  <td>{this.props.condition.scrip}</td>
                </tr>
                <tr>
                  <th>CE/PE Main Strike / CE/PE Hedge Strike:</th>
                  <td>{this.props.condition.ceMainStrike} / {this.props.condition.peMainStrike} / {this.props.condition.ceHedgeStrike} / {this.props.condition.peHedgeStrike}</td>
                </tr>
                <tr>
                  <th>Expiry (Type):</th>
                  <td>{this.props.condition.expiry} ({this.props.condition.expiryType})</td>
                </tr>
                <tr>
                  <th>Lots:</th>
                  <td>{this.props.condition.lots}</td>
                </tr>
                <tr>
                  <th>Start/Stop Time:</th>
                  <td>{this.props.condition.startTime} / {this.props.condition.stopTime}</td>
                </tr>
                <tr>
                  <th>Timeframe:</th>
                  <td>{this.props.condition.timeframe}</td>
                </tr>
                <tr>
                  <th>Trading Mode:</th>
                  <td>{this.props.condition.tradingMode}</td>
                </tr>
              </tbody>
            </table>

            <hr />

            <h4 className="is-size-4 mb-2">Statistics:</h4>

            <table className="table is-striped is-hoverable is-fullwidth is-bordered">
              <tbody>
                <tr>
                  <th>Stopped:</th>
                  <td>{this.props.condition.stopped ? "Yes" : "No"}</td>
                </tr>
                <tr>
                  <th>Status:</th>
                  <td>{this.props.condition.status}</td>
                </tr>
                <tr>
                  <th>CE/PE Main/Hedge Strike:</th>
                  <td>{this.props.condition.ceMainStrike} / {this.props.condition.peMainStrike} / {this.props.condition.ceHedgeStrike} / {this.props.condition.peHedgeStrike}</td>
                </tr>
                <tr>
                  <th>CE/PE Main/Hedge Entered Ins:</th>
                  <td>{this.props.condition.ceMainEnteredIns} / {this.props.condition.peMainEnteredIns} / {this.props.condition.ceHedgeEnteredIns} / {this.props.condition.peHedgeEnteredIns}</td>
                </tr>
                <tr>
                  <th>CE/PE Main/Hedge Entered Price:</th>
                  <td>{this.props.condition.ceMainEnteredPrice} / {this.props.condition.peMainEnteredPrice} / {this.props.condition.ceHedgeEnteredPrice} / {this.props.condition.peHedgeEnteredPrice}</td>
                </tr>
                <tr>
                  <th>CE/PE Main/Hedge LTP:</th>
                  <td>{this.props.condition.ceMainLtp} / {this.props.condition.peMainLtp} / {this.props.condition.ceHedgeLtp} / {this.props.condition.peHedgeLtp}</td>
                </tr>
                <tr>
                  <th>Running P&L:</th>
                  <td>{this.props.condition.runningPnl}</td>
                </tr>
                <tr>
                  <th>Booked P&L:</th>
                  <td>{this.props.condition.bookedPnl}</td>
                </tr>
                <tr>
                  <th>Number of Trades:</th>
                  <td>{this.props.condition.numberOfTrades}</td>
                </tr>
              </tbody>
            </table>
          </section>

          <footer className="modal-card-foot"></footer>
        </div>
      </div>
    );
  }
}

export default Strategy1InfoBox;